import React,{useEffect} from 'react'

import * as utils from './Helpers/MapsHelper'


const Maps = props => {

	useEffect(() => {
		utils.initializePerimeter(props.setPerimeterData,props.storage);
    console.log('perimeterInput:');
    console.log(document.getElementById('perimeterInput'));
	});

  return (
    <div className="step">
      <div className="vermMap">
        <div className="vermLeftContent how-to">
          <div className="perimeter-how-to-step">
            <div className="perimeter-how-to">1</div>
            <p>Adresse eingeben</p>
          </div>
          <hr></hr>
          <div className="perimeter-how-to-step">
            <div className="perimeter-how-to">2</div>
            <p>Aufnahmeperimeter einzeichnen</p>
          </div>
        </div>
        <div className="vermPerimeter">
          <div className="vermPerimeterHeading">{props.title}</div>
          <div className="vermPerimeterArea">m²</div>
          <div id="map_div" className="MapContent"></div>
        </div>
      </div> 
    </div>
    )
}

export default Maps